import {
  FormControl,
  Grid,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { getAllSites } from "../../../api/newsspecs/sites/SitesSpecsAPI";
import { getStandardTopics } from "../../../api/specialization/TopicSpecializationAPI";
import { OptionsObject, useSnackbar } from "notistack";
import { AuthorTopicChart } from "./AuthorTopicChart";
import { AuthorSourceChart } from "./AuthorSourceChart";
import { getFollowKeywords } from "../../../api/specialization/KeywordSpecializationAPI";
import {
  AlertSuccessProp,
} from "../../../components/SnackbarNoti";
import { AuthorKeywordChart } from "./AuthorKeywordChart";
import { useTranslation } from "react-i18next";
import { errorNoti } from "../../../util/SnackbarMessage";
import { PageHeader } from "../../../components/PageHeader";

function AuthorSpecializationPage() {
  const { t } = useTranslation(["common", "sidebar", "author"]);
  const [topics, setTopics] = useState([]);
  const [topicsDay, setTopicsDay] = useState(1);
  const [chosenTopic, setChosenTopic] = useState("Kinh tế");
  const [keywords, setKeywords] = useState([]);
  const [chosenKeyword, setChosenKeyword] = useState("Trendz");
  const [keywordDay, setKeywordDay] = useState(1);
  const [sites, setSites] = useState([]);
  const [chosenSite, setChosenSite] = useState("vnexpress");
  const [sourceDay, setSourceDay] = useState(1);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    getStandardTopics()
      .then((res) => setTopics(res))
      .catch((err) => {
        var noti = errorNoti(err);
        enqueueSnackbar(t("error:" + noti.message), noti.option);
      });
  }, []);

  useEffect(() => {
    getAllSites()
      .then((res) => setSites(res))
      .catch(() => {});
  }, []);

  useEffect(() => {
    getFollowKeywords()
      .then((response) => {
        setKeywords(response);
        setChosenKeyword(response[0]["keyword"]);
        enqueueSnackbar(
          "Load keywords successfully",
          AlertSuccessProp as OptionsObject
        );
      })
      .catch((err) => {
        var noti = errorNoti(err);
        enqueueSnackbar(t("error:" + noti.message), noti.option);
      });
  }, []);

  const topicButtons = topics.map(function (topic) {
    return (
      <MenuItem value={topic["standardTopic"]}>
        {topic["standardTopic"]}
      </MenuItem>
    );
  });

  let sitesUnique = [...new Set(sites)];
  const siteButtons = sitesUnique.map(function (site) {
    return <MenuItem value={site["name"]}>{site["name"]}</MenuItem>;
  });

  const keywordButtons = keywords.map(function (keyword) {
    return <MenuItem value={keyword["keyword"]}>{keyword["keyword"]}</MenuItem>;
  });

  return (
    <Grid container spacing={2}>
      <PageHeader text={t("author:author_stats")}></PageHeader>
      <Grid item xs={0.75}></Grid>
      <Grid item xs={5} className="grid-border white slide-from-left">
        <Typography variant="h6">
          {t("common:most_active_authors").toUpperCase()}{" "}
          {t("common:with").toUpperCase()} {t("sidebar:topics").toUpperCase()}
          <FormControl style={{ width: "200px", height: "15px" }}>
            <Select
              value={chosenTopic}
              onChange={(event: SelectChangeEvent) => {
                setChosenTopic(event.target.value as string);
              }}
              style={{ height: "25px" }}
            >
              {topicButtons}
            </Select>
          </FormControl>{" "}
          {t("common:within").toUpperCase()}{" "}
          <TextField
            id="topics-days-input"
            className="number-inline-input"
            style={{ width: "50px", height: "15px" }}
            inputProps={{
              inputMode: "numeric",
              //   pattern: "[0-9]*",
              min: 0,
              defaultValue: 12,
              placeholder: "Số giờ gần nhất",
              value: topicsDay,
              onChange: (event: any) => {
                if (parseInt(event.currentTarget.value)) {
                  setTopicsDay(parseInt(event.currentTarget.value));
                }
              },
            }}
          />{" "}
          {t("common:recent_days")}
        </Typography>

        <AuthorTopicChart topic={chosenTopic} days={topicsDay} />
      </Grid>
      <Grid item xs={0.5}></Grid>
      <Grid item xs={5} className="grid-border white slide-from-right">
        <Typography variant="h6">
          {t("common:most_active_authors").toUpperCase()}{" "}
          {t("common:of").toUpperCase()} {t("sidebar:sites").toUpperCase()}
          <FormControl style={{ width: "200px", height: "25px" }}>
            <Select
              value={chosenSite}
              onChange={(event: SelectChangeEvent) => {
                setChosenSite(event.target.value as string);
              }}
              style={{ height: "25px" }}
            >
              {siteButtons}
            </Select>
          </FormControl>
          {t("common:within").toUpperCase()}{" "}
          <TextField
            id="sources-days-input"
            className="number-inline-input"
            style={{ width: "50px", height: "15px" }}
            inputProps={{
              inputMode: "numeric",
              pattern: "[0-9]*",
              min: 0,
              defaultValue: 1,
              placeholder: "Số ngày gần nhất",
              value: sourceDay,
              onChange: (event: any) => {
                setSourceDay(parseInt(event.currentTarget.value) || 0);
              },
            }}
          />{" "}
          {t("common:recent_days")}
        </Typography>

        <AuthorSourceChart source={chosenSite} days={sourceDay} />
      </Grid>
      <Grid item xs={0.75}></Grid>
      <Grid item container xs={12} marginTop={2} spacing={2}>
        <Grid item xs={0.75}></Grid>
        <Grid
          item
          xs={5}
          sx={{ marginTop: "20px" }}
          className="grid-border white slide-from-left"
        >
          <Typography variant="h6">
            {t("common:most_active_authors").toUpperCase()}{" "}
            {t("common:with").toUpperCase()}{" "}
            {t("sidebar:keyword").toUpperCase()}
            <FormControl style={{ width: "200px", height: "26px" }}>
              <Select
                value={chosenKeyword}
                onChange={(event: SelectChangeEvent) => {
                  setChosenKeyword(event.target.value as string);
                }}
                style={{ height: "25px" }}
              >
                {keywordButtons}
              </Select>
            </FormControl>
            {t("common:within").toUpperCase()}{" "}
            <TextField
              id="keywords-days-input"
              className="number-inline-input"
              style={{ width: "50px", height: "15px" }}
              inputProps={{
                inputMode: "numeric",
                pattern: "[0-9]*",
                min: 0,
                defaultValue: 1,
                placeholder: "Số ngày gần nhất",
                value: keywordDay,
                onChange: (event: any) => {
                  setKeywordDay(parseInt(event.currentTarget.value) || 0);
                },
              }}
            />{" "}
            {t("common:recent_days")}
          </Typography>
          <AuthorKeywordChart keyword={chosenKeyword} days={keywordDay} />
        </Grid>
      </Grid>
    </Grid>
  );
}
export default AuthorSpecializationPage;
